'use client';

import { preload } from 'react-dom';

interface ImageResourceHintProps {
  href: string;
  imageSrcSet?: string;
  imageSizes?: string;
}

/** 与 next/image 使用同一 React 预加载注册表，SSR 和水合均不会重复提示。 */
export default function ImageResourceHint(props: ImageResourceHintProps) {
  preload(props.href, {
    as: 'image',
    imageSrcSet: props.imageSrcSet,
    imageSizes: props.imageSizes,
    fetchPriority: 'high',
  });
  return null;
}
